import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  GetNspProductsInPack,
  GetNspStandaloneProducts,
} from '../store/actions/nsp.actions';
import { OnDestroyHookDirective } from '../../shared/hooks';
import { getPiiNsp } from '../../shared/pii/pii.utils';
import { Product } from '@dch/products-business-logic';
import {
  getNspProductsInPack,
  getNspProductsInPackPending,
  getNspProductsInPackTechnicalError,
  getNspStandaloneProducts,
  getNspStandaloneProductsPending,
  getNspStandaloneTechnicalError,
} from '../../store/reducers';
import { InceptionService, TranslationService } from '@proximus/ng-common';
import {
  getNspInternetProducts,
  getNspMobileProducts,
} from '../utils/nsp.utils';
import { NspBasketModalComponent } from '../nsp-basket-modal/nsp-basket-modal.component';
import { ModalService } from '@proximus/ng-common-components';

@Component({
  selector: 'mprd-nsp-activation-internet-container',
  templateUrl: './nsp-activation-internet-container.component.html',
})
export class NspActivationInternetContainerComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  internetProducts: Product[];
  productsLoaded = false;
  pending = false;
  error = false;
  subtitleKey: string;
  /**
   * it init with -1 ( to show the skeleton)
   * the possible value during OnInit() >= 0 ( number of mobiles contains in the product)
   * */
  mobileProductCount = -1;

  constructor(
    private router: Router,
    private store: Store,
    private inceptionService: InceptionService,
    private modalService: ModalService,
    private translationService: TranslationService,
  ) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this.store.select(getNspProductsInPack).subscribe((products) => {
        this.internetProducts = getNspInternetProducts(products);
        if (this.mobileProductCount <= 0) {
          this.mobileProductCount = getNspMobileProducts(products).length;
        }
        this.productsLoaded = products && products.length > 0;
      }),
    );

    this.addSubscription(
      this.store.select(getNspProductsInPackPending).subscribe((pending) => {
        this.pending = pending;
      }),
    );
    this.addSubscription(
      this.store
        .select(getNspProductsInPackTechnicalError)
        .subscribe((error) => {
          this.error = !!error;
        }),
    );
    this.addSubscription(
      this.store.select(getNspStandaloneProducts).subscribe((products) => {
        this.internetProducts = getNspInternetProducts(products);
        if (this.mobileProductCount <= 0) {
          this.mobileProductCount = getNspMobileProducts(products).length;
        }
        this.productsLoaded = products && products.length > 0;
      }),
    );
    this.addSubscription(
      this.store
        .select(getNspStandaloneProductsPending)
        .subscribe((pending) => {
          this.pending = pending;
        }),
    );
    this.addSubscription(
      this.store.select(getNspStandaloneTechnicalError).subscribe((error) => {
        this.error = !!error;
      }),
    );

    const { packId, productId } = getPiiNsp();
    if (packId || productId) {
      packId
        ? this.store.dispatch(new GetNspProductsInPack({ packId }))
        : this.store.dispatch(new GetNspStandaloneProducts({ productId }));
      if (this.hasMobileProducts) {
        this.subtitleKey = 'nsp.activationInternet.subtitle';
      } else if (!this.hasMobileProducts) {
        this.subtitleKey = 'nsp.activationInternet.standalone.subtitle';
      }
    } else if (!this.pending && this.internetProducts.length === 0) {
      this.router.navigate(['/overview']);
    }
    this.scrollToTop();
    this.inceptionService.init();
  }

  goToNextStep() {
    if (this.isStandAlone) {
      this.modalService
        .create<NspBasketModalComponent>(NspBasketModalComponent)
        .subscribe((componentRef) => {
          componentRef.instance.isStandalone = true;
          componentRef.instance.isActivationFlow = true;
        });
    } else {
      this.router.navigate(['/nspActivationMobile']);
    }
  }

  get hasMobileProducts() {
    return this.mobileProductCount > 0;
  }

  get isStandAlone() {
    return !this.hasMobileProducts && this.internetProducts.length > 0;
  }

  scrollToTop(): void {
    setTimeout(() => {
      this.inceptionService.scrollToElement('#nspActivationInternetContainer');
    });
  }

  getTaggingButtonName() {
    const name = this.isStandAlone
      ? 'nsp.activationMobile.button.continue'
      : 'nsp.activationInternet.button.continue';
    return this.translationService.getTranslatedValueFor(name);
  }
}
